module.exports = __webpack_public_path__ + "img/side exposed 10mm zipper length.c02a3aa9.png";